import { CSSObject } from 'styled-components';

const setInterparagraph = (size: string): CSSObject => {
  const nodes = ['p', 'ul', 'ol', 'li'];

  const css: CSSObject = {};

  nodes.forEach(node => {
    css[`div, & > div, & > ${node}`] = {
      marginTop: size,

      '&:first-child': {
        marginTop: 0,
      },
    };

    nodes.forEach(siblingNode => {
      css[`& div ${node} + ${siblingNode}, & ${node} + ${siblingNode}`] = {
        marginTop: size,
      };
    });
  });

  return css;
};

export default setInterparagraph;
